import { render, staticRenderFns } from "./CardAuthorityOrganization.vue?vue&type=template&id=6db75364"
import script from "./CardAuthorityOrganization.vue?vue&type=script&lang=js"
export * from "./CardAuthorityOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports